import React from 'react';
import PropTypes from 'prop-types';
import './image-card.scss';
import imageThumbnail from '../../../images/image-thumbnail.png';
import { Link } from "gatsby"
import { slice } from 'lodash';

const ImageCard = (props) => {

    const { cardStyle, page, shReadDurationMap, customStyle, logout } = props;

    if (!page || page.status !== 'publish') {
        return null;
    }

    const cardTitle = (page && page.title) ? page.title : '';
    const title = slice(cardTitle, 0, 45);

    const mostRead = (<>
        <div className={`w3-hide-medium w3-hide-large pw-ic-mo ${customStyle ? "w3-show" : "w3-hide"}`}>
            x Remove
        </div>
        <div className={`pw-image-card ${customStyle} ${page ? "row" : cardStyle ? cardStyle : 'column'}`}>
            <div className="pw-ic-img-container">
                <img loading="lazy" src={page ? `${page.acf_super_honestly.thumbnail.sourceUrl}` : imageThumbnail}
                    alt={cardTitle}
                    className="pw-ic-thumbnail"
                />
            </div>
            <div className="pw-ic-content">
                <div className={page ? "page pw-ic-description" : "pw-ic-description"}>
                    {cardTitle.length > 47 ? `${title.join('')}...` : cardTitle}
                </div>
                <div className="w3-row">
                    <div className="w3-col m6 pw-ic-ttread">
                        {page ? `${(shReadDurationMap && shReadDurationMap[page.slug]) ? shReadDurationMap[page.slug] : 'x'} min read` : ""}
                    </div>
                    <div className={`w3-hide-small w3-col m6 pw-ic-ttread color ${!customStyle ? "w3-hide" : !logout ? "w3-show" : "w3-hide"}`}>
                        x Remove
                    </div>
                </div>
            </div>
        </div>
    </>)
    const w3Class = logout ? 'm12 l12' : page ? 'm6 l6' : cardStyle && cardStyle === 'row' ? 'm4 l4' : 'm2 l2'
    return (
        <div className={`w3-col ${w3Class}`}>
            {page ? <Link to={`/super-honestly/${page.slug}`} style={{textDecoration: "none", display: "flex"}}>
                {mostRead}
        </Link> : mostRead }
    </div>
    );
}

ImageCard.propTypes = {
    cardStyle: PropTypes.string
};

ImageCard.defaultProps = {
    cardStyle: 'column'
};


export default ImageCard;
